import { z } from 'zod';
import { modelSchema } from '../base';

const textBlockSchema = z.object({
  type: z.literal('text'),
  data: z.string(),
  key: z.guid().optional(),
});

const taskDataSchema = z.object({
  title: z.string(),
  parentGoalId: z.guid().optional(),
  period: z.enum(['day', 'week']).optional(),
});

const taskBlockStatusSchema = z
  .enum(['suggested', 'added', 'skipped', 'revised'])
  .default('suggested');

const taskBlockSchema = z.object({
  type: z.literal('entity'),
  entityType: z.literal('task'),
  data: taskDataSchema,
  status: taskBlockStatusSchema,
  key: z.guid().optional(),
});

export const blockSchema = z.discriminatedUnion('type', [
  textBlockSchema,
  taskBlockSchema,
]);

export const blocksSchema = z.array(blockSchema);

export const toolCallSchema = z.object({
  name: z.string(),
});

export const toolCallsSchema = z.array(toolCallSchema);

const baseChatMessageSchema = z.object({
  conversationId: z.string(),
  role: z.enum(['user', 'assistant']),
  blocks: z.array(blockSchema),
});

export const chatMessageSchema = baseChatMessageSchema.extend(
  modelSchema.shape,
);
